import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './EventPublish.css';
import { Dialog } from '@avalara/skylab-react';
import { makePostRequest } from '../helpers/biztechAxiosRequest';
import { REPROVISION } from '../constants/ApiEndpoints';
import { sendNotification } from '../utils/notification';

export default class EmergencyReprovision extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketNumber: '',
      ticketPrefix: 'PLAUNCH',
      env: 'prd'
    };
  }

  handleInputChange = event => {
    const { name, value } = event.target;
    if (name === 'ticketNumber' && value !== '' && !/^\d*$/.test(value)) {
      return;
    }
    this.setState({ [name]: value });
  };

  isTicketNumberValid = () => /^\d+$/.test(this.state.ticketNumber);

  submitHandler = event => {
    event.preventDefault();
    this.props.toggleDialog();
    this.props.loadingStateChanger(true);

    // Correlation id format: REPR_CRMID_TICKET_UUID
    const ticket = `${this.state.ticketPrefix}-${this.state.ticketNumber}`;
    const correlationId = `REPR_${
      this.props.crmId
    }_${ticket}`;

    // The reprovision API only needs crmId in the body; env selects the target
    // provisioning host (prd/sbx). The correlation id is sent as a header and
    // forwarded to the provisioning service as X-Correlation-Id.
    const payload = {
      env: this.state.env,
      crmId: this.props.crmId
    };

    makePostRequest(REPROVISION, payload, {
      headers: { 'X-Correlation-Id': correlationId }
    })
      .then(() => {
        return sendNotification(
          'Reprovisioning request submitted successfully !!'
        );
      })
      .catch(() => {
        return sendNotification('Error submitting Reprovisioning request');
      })
      .finally(() => {
        this.setState({
          ticketNumber: '',
          ticketPrefix: 'PLAUNCH',
          env: 'prd'
        });
        this.props.loadingStateChanger(false);
      });
  };

  render() {
    return (
      <Dialog open={this.props.showDialog} id="emergencyReprovisionDialog">
        <fieldset className="padding-20">
          <div slot="header" id="dialog-title">
            <h1 className="text-center margin-all-xs">
              Emergency Reprovisioning
            </h1>
          </div>
          <hr />
          <form onSubmit={this.submitHandler}>
            <div slot="body">
            <s-row>
              <s-col span="6">
                <label>Customer Account Id</label>
              </s-col>
              <s-col span="6">
                <label>{this.props.crmId}</label>
              </s-col>
            </s-row>
            <hr />
            <label>Enter Ticket Details</label>
            <s-row>
              <s-col span="6">
                <select
                  name="ticketPrefix"
                  value={this.state.ticketPrefix}
                  onChange={this.handleInputChange}
                >
                  <option value="PLAUNCH">PLAUNCH</option>
                  <option value="PROV">PROV</option>
                  <option value="PULSE">PULSE</option>
                </select>
              </s-col>
              <s-col span="6">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]+"
                  title="Ticket number must contain only digits"
                  placeholder="Ticket Number"
                  name="ticketNumber"
                  value={this.state.ticketNumber}
                  onChange={this.handleInputChange}
                  required
                />
              </s-col>
            </s-row>
            <hr />
            <label>Select Environment</label>
            <s-row>
              <s-col span="6">
                <select
                  name="env"
                  value={this.state.env}
                  onChange={this.handleInputChange}
                >
                  <option value="prd">Production</option>
                  <option value="sbx">Sandbox</option>
                </select>
              </s-col>
            </s-row>
            </div>
            <hr />
            <label className="secondaryRed">
              Note: This will trigger an <b>emergency reprovisioning</b>
              <br />
              request for this customer account.
            </label>
            <hr />
            <div slot="footer">
              <button
                type="button"
                className="secondary cancelButton small"
                onClick={this.props.toggleDialog}
              >
                Cancel
              </button>
              <button
                className="primary float-right"
                type="submit"
                disabled={!this.isTicketNumberValid()}
              >
                Submit
              </button>
            </div>
          </form>
        </fieldset>
      </Dialog>
    );
  }
}
